export * from './lib/app-client-shared-components-notifications-data-access.module';
